<script lang="ts">
	/**
	 * Root layout.
	 *
	 * Holds the two effects that are genuinely app-wide, applying the theme palette and
	 * following the OS colour-scheme preference, so that every route, including the
	 * error page, is themed. The map shell does not repeat them.
	 */
	import '../app.css';
	import { themeState } from '$lib/state/theme.svelte';

	let { children } = $props();

	/** Writes the configured palette to the document whenever the scheme changes. */
	$effect(() => {
		themeState.apply();
	});

	/** Keeps `system` live, rather than snapshotting the OS preference at load. */
	$effect(() => themeState.watchSystem());
</script>

{@render children()}
